<template>
  <ContentLayout
    :title="$t('label_essweb_shift_form_newTitle')"
    pad="0"
    :initData="shiftData"
    @change="(changed) => (isChanged = changed)"
    :checkData="[
      'shift_name',
      'sequence',
      'shift_description',
      'shift_abbr',
      'start_utc_time',
      'end_utc_time',
      'total_working_minutes',
      'color_code',
      'shift_code',
      'default_site_uuid',
      'effective_utc_datetime',
      'expired_utc_datetime',
      'shift_property_group_uuid',
      'remarks',
    ]"
    widthClass="max-1000"
  >
    <!-- content -->
    <template v-slot:page-main>
      <Stepper :curStep="curStep" :items="stepper">
        <template v-slot:content-1>
          <v-form ref="form" lazy-validation class="pa-2">
            <v-row justify="start" class="white lighten-5">
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <inputTextFiledMultiLang
                  :bindData="shiftData.shift_name"
                  maxlength="100"
                  @change="
                    (valueArr) => {
                      shiftData.shift_name = valueArr;
                    }
                  "
                  :label="$t('label_essweb_shift_form_shiftNameLabel')"
                  :rules="$GetRules(['_Require_Rules'], [null])"
                />
              </v-col>
              <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                <!-- 2020-09-03修改为非国际化 -->
                <normalInputTextFiled
                  v-model="shiftData.shift_abbr"
                  maxlength="20"
                  :rules="$GetRules(['_Require_Rules'], [null])"
                  :label="$t('label_essweb_shift_form_shiftAbbrLabel')"
                />
              </v-col>
              <v-col xs="12" sm="4" md="4" lg="4" cols="12">
                <normalInputTextFiled
                  :label="$t('label_essweb_ClaimReason_form_codeLabel')"
                  maxlength="100"
                  :rules="
                    $GetRules(['_Require_Rules', '_Length_Rules'], [null, 100])
                  "
                  v-model="shiftData.shift_code"
                />
              </v-col>
              <v-col xs="12" sm="4" md="4" lg="4" cols="12">
                <normalInputTextFiled
                  :label="$t('label_essweb_shift_form_sequenceLabel')"
                  type="number"
                  maxlength="255"
                  :rules="
                    $GetRules(
                      ['_Number_negative', '_Length_Rules'],
                      [null, 255]
                    )
                  "
                  v-model="shiftData.sequence"
                />
              </v-col>

              <v-col xs="12" sm="4" md="4" lg="4" cols="12">
                <v-sheet class="mrc_text_require text--secondary">{{
                  $t("label_essweb_shift_form_tagColorLabel")
                }}</v-sheet>
                <SelectColor
                  :items="Colors"
                  v-model="shiftData.color_code"
                  :rules="$GetRules(['_Require_Rules'], [null])"
                />
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <inputTextFiledMultiLang
                  :bindData="shiftData.shift_description"
                  maxlength="500"
                  @change="
                    (valueArr) => {
                      shiftData.shift_description = valueArr;
                    }
                  "
                  :label="$t('label_essweb_shift_form_descriptionLabel')"
                />
              </v-col>

              <v-col xs="12" sm="12" md="12" lg="12" cols="12" class="px-1">
                <Tabler :headers="headers" :items="desserts" border>
                  <template v-slot:item.type="{ item }">
                    {{ $getCommonLangValue(item.type) }}
                  </template>
                  <template v-slot:item.name="{ item }">
                    <div class="text--primary table-title">
                      {{ $getCommonLangValue(item.name) }}
                    </div>
                  </template>
                  <template v-slot:item.startTime="{ item }">
                    <div class="text--primary table-title">
                      {{ $timeMachine(item.startTime) }}
                    </div>
                  </template>
                  <template v-slot:item.endTime="{ item }">
                    <div class="text--primary table-title">
                      {{ $timeMachine(item.endTime) }}
                    </div>
                  </template>
                  <template v-slot:item.total="{ item }">
                    <div class="text--primary table-title">
                      {{ Number(item.endTime) - Number(item.startTime)
                      }}{{ $t("label_essweb_system_minutesLabel") }}
                    </div>
                  </template>
                  <template v-slot:item.group="{ item }">
                    <v-btn icon @click="toViewProperty(item)">
                      <span class="material-icons-round">search</span>
                    </v-btn>
                  </template>
                  <template v-slot:item.action="{ item }">
                    <v-btn icon @click="toEditMapping(item)" v-if="false">
                      <span class="material-icons-round">edit</span>
                    </v-btn>

                    <v-btn icon @click="toDelete(item)">
                      <span class="material-icons-round">delete</span>
                    </v-btn>
                  </template>
                  <template v-slot:footer>
                    <v-divider></v-divider>
                    <v-btn
                      text
                      small
                      color="primary"
                      class="text-capitalize my-2 text-button"
                      @click="toNewMapping"
                    >
                      {{ $t("label_essweb_shift_form_addEventBtnLabel")
                      }}<span class="material-icons-round">add</span>
                    </v-btn>
                  </template>
                </Tabler>
                <v-sheet class="text--secondary pl-1 text-left"
                  >{{
                    $t("label_essweb_shift_form_totalMinutesLabel") + " "
                  }}:{{ totalMin
                  }}{{ $t("label_essweb_system_minutesLabel") }}</v-sheet
                >
              </v-col>

              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <AutoComplete
                  isRequired
                  :items="ShiftTypeList"
                  item-text="shift_type_name"
                  label="label_essweb_shift_form_shiftTypeLabel"
                  item-value="uuid"
                  chips
                  :rules="$GetRules(['_Require_ArrRules'], [null])"
                  multiple
                  deletable-chips
                  v-model="shiftData.shift_type_uuid"
                >
                  <template v-slot:selection="{ data }">
                    {{ $getCommonLangValue(data.item.shift_type_name) }}
                  </template>
                  <template v-slot:item.title="{ data }">
                    {{ $getCommonLangValue(data.item.shift_type_name) }}
                  </template>
                </AutoComplete>
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <AutoComplete
                  :items="defaultSiteList"
                  item-text="site_name"
                  label="label_essweb_shift_form_siteNameLabel"
                  item-value="uuid"
                  chips
                  deletable-chips
                  v-model="shiftData.default_site_uuid"
                >
                  <template v-slot:selection="{ data }">
                    {{ $getCommonLangValue(data.item.site_name) }}
                  </template>
                  <template v-slot:item.title="{ data }">
                    {{ $getCommonLangValue(data.item.site_name) }}
                  </template>
                </AutoComplete>
              </v-col>
              <v-col xs="12" sm="6" md="4" lg="4" cols="12">
                <DateTimePicker
                  type="date"
                  :label="$t('label_essweb_shift_form_effectiveDateLabel')"
                  :defaultTime="shiftData.effective_utc_datetime"
                  placeholder="YYYY/MM/DD"
                  :max="shiftData.expired_utc_datetime"
                  :rules="$GetRules(['_Require_Rules'], [null])"
                  @change="
                    (time) => {
                      shiftData.effective_utc_datetime = time;
                    }
                  "
                />
              </v-col>
              <v-col xs="12" sm="6" md="4" lg="4" cols="12">
                <DateTimePicker
                  :min="shiftData.effective_utc_datetime"
                  type="date"
                  :label="$t('label_essweb_shift_form_expireDateLabel')"
                  :defaultTime="shiftData.expired_utc_datetime"
                  placeholder="YYYY/MM/DD"
                  @change="
                    (time) => {
                      shiftData.expired_utc_datetime = time;
                    }
                  "
                ></DateTimePicker>
              </v-col>
              <v-col xs="12" sm="6" md="4" lg="4" cols="12">
                <v-sheet class="text--secondary">{{
                  $t("label_essweb_shift_form_timeZoneLabel")
                }}</v-sheet>
                <v-select
                  :items="staticZone"
                  filled
                  single-line
                  :menu-props="{
                    offsetY: true,
                    transition: 'slide-y-transition',
                    rounded: true,
                    contentClass: 'elevation-4',
                  }"
                  item-text="text"
                  item-value="utc"
                  v-model="shiftData.expired_time_zone"
                  :label="$t('label_essweb_shift_form_timeZoneLabel')"
                  dense
                >
                  <template v-slot:no-data> <noContent /> </template>
                </v-select>
              </v-col>
              <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                <AutoComplete
                  isRequired
                  :items="ShiftPorpertyGroup"
                  item-text="shift_property_group_name"
                  item-value="uuid"
                  label="label_essweb_shift_form_shiftPropertyGroupLabel"
                  v-model="shiftData.shift_property_group_uuid"
                  :rules="$GetRules(['_Require_Rules'], [null])"
                  :placeholder="
                    $t('label_essweb_shift_form_shiftPropertyGroupLabel')
                  "
                >
                  <template v-slot:selection="{ data }">
                    {{
                      $getCommonLangValue(data.item.shift_property_group_name)
                    }}
                  </template>
                  <template v-slot:item.title="{ data }">
                    {{
                      $getCommonLangValue(data.item.shift_property_group_name)
                    }}
                  </template>
                </AutoComplete>
              </v-col>
            </v-row>
          </v-form>
        </template>
        <template v-slot:content-2>
          <v-sheet
            class="max-width pa-3 d-flex flex-row justify-space-between"
            height="50"
          >
            <div class="title">
              {{ $t("label_essweb_shift_form_step_punchMethodLabel") }}
            </div>
            <v-spacer></v-spacer>
            <div class="text-right align-right">
              <v-btn
                rounded
                outlined
                text
                class="text-capitalize mx-2"
                color="primary"
                @click="toCopyFromShift"
                >{{ $t("label_essweb_shift_form_copyFromAnotherShift") }}</v-btn
              >
              <v-btn
                rounded
                outlined
                text
                class="text-capitalize mx-2"
                color="primary"
                @click="toAddGroup"
                >{{ $t("label_essweb_shift_form_addSiteBtnLabel")
                }}<span class="material-icons-round">add</span>
              </v-btn>
            </div>
          </v-sheet>
          <noContent v-if="SiteMappingData.length == 0" />
          <SpecialTable
            isHead
            :headers="siteHeader"
            :key="index"
            showFooter
            v-for="(item, index) in SiteMappingData"
            :tableTitle="item.site_name"
            type="site"
            :type_uuid="item.site_uuid"
            @onNew="toAddCriteriaType"
            @onDelete="toDeleteCriteriaType"
            @onDeleteGroup="toDeleteGroup(item.site_uuid)"
            :items="item.items ? item.items : []"
            newBtn="label_essweb_shift_form_criteriaTypeLabel"
          />
        </template>
      </Stepper>
    </template>
    <!-- content -->
    <template v-slot:page-actions>
      <CardActions
        :newBtn="stepper.length == curStep && curStep != 0 ? true : false"
        :step="stepper.length == curStep ? false : true"
        @next="toNext"
        :preStep="curStep > 1 ? true : false"
        @pre="curStep = curStep - 1"
        @new="toNew"
        @cancel="$toBack(isChanged)"
      />
    </template>
    <!-- tools -->
    <template v-slot:tools-main>
      <mapEventShift
        :show="mapToDialog"
        :action="curAction"
        @closeDialog="mapToDialog = false"
        :mapData="curMapData"
        @new="onNewMapping"
        @edit="onEditMapping"
      />
      <newGroupMapping
        :show="newGroupMapDialog"
        @new="toNewGroup"
        @close="newGroupMapDialog = false"
      />
      <newCriteriaTypeDialog
        :show="showCriteriaTypeDialog"
        :site="curSite"
        @close="showCriteriaTypeDialog = false"
        @new="onNewCriteriaType"
      />
      <copyFromShift
        :show="showCopyShift"
        :curentShift="''"
        @close="showCopyShift = false"
        @new="onCopyFromShift"
      />
      <viewProperty
        :group_uuid="curGroupUuid"
        :show="showPropertyList"
        @close="showPropertyList = false"
      />
    </template>
    <!-- tools end -->
  </ContentLayout>
</template>
<script>
import copyFromShift from "@/Page/EssAdmin/Shift/ShiftList/components/copyFromShift";
import viewProperty from "@/Page/EssAdmin/Shift/ShiftList/components/viewProperty";
import mapEventShift from "@/Page/EssAdmin/Shift/ShiftList/components/mapEventShift";
import newGroupMapping from "@/Page/EssAdmin/Shift/ShiftList/components/newGroupMapping";
import newCriteriaTypeDialog from "@/Page/EssAdmin/Shift/ShiftList/components/newCriteriaTypeDialog";
import { mapGetters } from "vuex";

export default {
  name: "newShift",
  components: {
    mapEventShift,
    newGroupMapping,
    newCriteriaTypeDialog,
    copyFromShift,
    viewProperty,
  },
  computed: {
    ...mapGetters(["companyLang", "staticZone", "defaultUTC"]),
    ShiftTypeList() {
      return this.$getSelectTrans(this.ShiftTypeListData, "shift_type_name");
    },
    defaultSiteList() {
      return this.$getSelectTrans(this.defaultSiteListData, "site_name");
    },
    costCenter() {
      return this.$getSelectTrans(this.costCenterData, "view_fields");
    },
    curEventList() {
      var arr = [];
      this.desserts.forEach((item, index) => {
        arr.push({
          event_uuid: item.event_uuid,
          event_type_uuid: item.type_uuid,
          remarks: "",
        });
      });
      return arr;
    },
    curCriteriaTypeList() {
      var arr = [];
      this.SiteMappingData.forEach((item, index) => {
        item.items.forEach((it, index) => {
          arr.push({
            site_uuid: item.site_uuid,
            criteria_type_uuid: it.criteriaType.uuid,
            criteria_uuid: it.criteria ? it.criteria.uuid : "",
            is_required: 1,
            remarks: "",
          });
        });
      });
      return arr;
    },
    timeTerminal() {
      return this.getTimeTerminal();
    },
    totalMin() {
      let total = 0;
      this.desserts.map((item) => {
        total = total + (Number(item.endTime) - Number(item.startTime));
      });
      return total;
    },
  },
  watch: {
    desserts(val) {},
  },
  data() {
    return {
      Colors: [],
      isLoading: false,
      SiteLoading: false,
      curGroupUuid: null,
      isChanged: false,
      showPropertyList: false,
      defaultSiteListData: [],
      costCenterData: [],
      stepper: [
        "label_essweb_shift_form_step_generalLabel",
        "label_essweb_shift_form_step_punchMethodLabel",
      ],
      mapToDialog: false,
      newGroupMapDialog: false,
      showCopyShift: false,
      curSite: null,
      curSiteUuid: null,
      showCriteriaTypeDialog: false,
      search: "",
      curStep: 1,
      SiteMappingData: [],
      curAction: "new",
      curMapData: {
        id: null,
        curEvent: "",
        curType: "",
      },
      siteHeader: [
        {
          text: "label_essweb_shiftform_event_list_eventTypeLabel",
          value: "type",
          width: 400,
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_shiftform_event_list_eventNameLabel",
          value: "name",
          width: 400,
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_shift_list_shiftActionsLabel",
          value: "action",
          align: "start",
          sortable: false,
        },
      ],
      curItem: null,
      showSelect: false,
      selected: [],
      page: 1,
      shiftData: {
        uuid: null,
        shift_name: "",
        sequence: 1,
        shift_description: "",
        shift_abbr: "",
        shift_code: "",
        shift_type_uuid: "",
        default_site_uuid: "",
        // cost_center_uuid:'',
        start_utc_time: "",
        start_time_time_zone: 0,
        end_utc_time: "",
        end_time_time_zone: 0,
        total_working_minutes: 0,
        color_code: "",
        effective_utc_datetime: "",
        effective_time_zone: 0,
        expired_utc_datetime: "",
        expired_time_zone: 0,
        shift_property_group_uuid: "",
        remarks: "",
      },
      headers: [
        {
          text: "label_essweb_event_list_eventTypeLabel",
          value: "type",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_event_list_eventNameLabel",
          value: "name",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_event_list_startTimeLabel",
          value: "startTime",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_event_list_endTimeLabel",
          value: "endTime",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_event_list_totalMinutesLabel",
          value: "total",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_event_form_eventPropertyGroupLabel",
          value: "group",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_shift_list_shiftActionsLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      desserts: [],
      ShiftTypeListData: [],
      ShiftPorpertyGroup: [],
    };
  },
  mounted() {
    const that = this;
    this.shiftData.effective_time_zone = this.defaultUTC;
    this.shiftData.expired_time_zone = this.defaultUTC;
    this.getType();
    this.getColors();
    this.getCostCenter();
    this.getDefaultSiteList();
    this.getPorpertyGroup();
  },
  methods: {
    getColors() {
      const that = this;
      this.$findPrompt({
        prompt_name: "ess_color_shift_select",
      }).then((res) => {
        that.Colors = [];
        res.data.map((item) => {
          that.Colors.push({
            text: item.view_fields,
            color: item.value_field,
          });
        });
      });
    },
    getCostCenter: function () {
      const that = this;
      this.$findPrompt({
        prompt_name: "ess_cost_center_select",
      }).then((res) => {
        that.costCenterData = res.data;
      });
    },
    removeType: function (item) {
      const index = this.shiftData.shift_type_uuid.indexOf(item.uuid);
      if (index >= 0) this.shiftData.shift_type_uuid.splice(index, 1);
    },
    toViewProperty: function (item) {
      if (item["group_uuid"]) {
        this.curGroupUuid = item["group_uuid"];
        this.showPropertyList = true;
      }
    },
    getTimeTerminal: function () {
      if (this.desserts.length == 0) {
        this.shiftData.total_working_minutes = 0;
        return {
          start_time: "0",
          start_utc: this.defaultUTC,
          end_time: "0",
          end_utc: this.defaultUTC,
        };
      } else {
        this.shiftData.total_working_minutes = 0;
        var min = Number(this.desserts[0].startTime),
          minUtc = this.desserts[0].startUtc,
          maxUtc = this.desserts[0].endUtc,
          max = Number(this.desserts[0].endTime);
        this.desserts.forEach((item, index) => {
          if (Number(item.startTime) < min) {
            min = Number(item.startTime);
            minUtc = item.startUtc;
          }
          if (Number(item.endTime) > max) {
            max = Number(item.endTime);
            maxUtc = item.endUtc;
          }
          this.shiftData.total_working_minutes =
            this.shiftData.total_working_minutes +
            (Number(item.endTime) - Number(item.startTime));
        });
        return {
          start_time: min.toString(),
          start_utc: minUtc,
          end_time: max.toString(),
          end_utc: maxUtc,
        };
      }
    },
    toNext: function () {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.curStep = this.curStep + 1;
    },
    getType: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_shift_type",
        url: "/shift-type/get-shift-type-list/",
      }).then((res) => {
        that.ShiftTypeListData = res.data;
      });
    },
    getDefaultSiteList: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_site",
        url: "/site/get-site-list/",
      }).then((res) => {
        that.defaultSiteListData = res.data;
      });
    },
    getPorpertyGroup: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_shift_property_group",
        url: "/shift-property-group/get-shift-property-group-list/",
      }).then((res) => {
        res.data.map((item) => {
          item.shift_property_group_name = that.$getCommonLangValue(
            item.shift_property_group_name
          );
        });
        that.ShiftPorpertyGroup = res.data;
      });
    },
    toAddGroup: function () {
      this.newGroupMapDialog = true;
    },
    toNewGroup: function (site) {
      const that = this;
      this.newGroupMapDialog = false;
      var arr = this.SiteMappingData.filter(
        (ele) => ele.site_uuid === site.uuid
      );
      if (arr.length) {
        that.$showMessage({
          title: that.$t("message_essweb_form_textField_errNoticeTitle"),
          text: that.$t("error_essweb_shift_form_siteExistLabel"),
          okText: that.$t("message_essweb_form_textField_selectAgain"),
          type: "error",
        });
        return;
      } else {
        this.SiteMappingData.push({
          items: [],
          site_abbr: site.site_abbr,
          site_description: site.site_description,
          site_name: site.site_name,
          site_uuid: site.uuid,
        });
      }
    },
    toDeleteGroup: function (uuid) {
      const that = this;
      this.curUuid = uuid;
      this.$confirmDo(
        this.$t("label_essweb_shift_form_dialog_siteNameLabel")
      ).then((res) => {
        if (res) that.toConfirmDeleteGroup();
      });
    },
    toConfirmDeleteGroup: function () {
      this.SiteMappingData = this.SiteMappingData.filter(
        (ele) => ele.site_uuid !== this.curUuid
      );
    },
    toAddCriteriaType: function (type, typeid) {
      this.curSite = typeid;
      this.showCriteriaTypeDialog = true;
    },
    onNewCriteriaType: function (site, obj) {
      const that = this;
      this.showCriteriaTypeDialog = false;
      this.SiteMappingData.some(function (item, index) {
        if (item.site_uuid == site) {
          if (item.items.length <= 0) {
            item.items.push({
              site_abbr: obj.curSite.site_abbr,
              site_description: obj.curSite.site_description,
              site_name: obj.curSite.site_name,
              criteriaType: obj.curType,
              site_uuid: site,
              criteria: obj.curCriteria,
              uuid: 0,
            });
          } else {
            var maxid = 0;
            item.items.some((it, index) => {
              //2021-02-14 开放Wifi可以重复加入 Daveluo
              if (
                it.criteriaType.punch_code !== "WIFI" &&
                it.criteriaType.punch_code == obj.curType.punch_code
              ) {
                that.$showMessage({
                  title: that.$t(
                    "message_essweb_shift_form_criteriaTypeErrorTitle"
                  ),
                  text: that.$t(
                    "error_essweb_shift_form_criteriaTypeExistLabel"
                  ),
                  type: "error",
                });
                return true;
              } else {
                if (it.uuid > maxid) {
                  maxid = Number(it.uuid);
                }
                if (index == item.items.length - 1) {
                  item.items.push({
                    site_abbr: obj.curSite.site_abbr,
                    site_description: obj.curSite.site_description,
                    site_name: obj.curSite.site_name,
                    criteriaType: obj.curType,
                    site_uuid: site,
                    criteria: obj.curCriteria,
                    uuid: maxid + 1,
                  });
                }
              }
            });
          }
          return true;
        }
      });
    },
    toDeleteCriteriaType: function (type, obj, site) {
      const that = this;
      this.curUuid = obj.uuid; //
      this.curSiteUuid = site; //
      this.$confirmDo(
        this.$t("label_essweb_shift_form_dialog_criteriaTypeLabel")
      ).then((res) => {
        if (res) that.toConfirmDeleteCriteria();
      });
    },
    toConfirmDeleteCriteria: function () {
      const that = this;
      this.SiteMappingData.some(function (item, index) {
        if (item.site_uuid === that.curSiteUuid) {
          item.items = item.items.filter((ele) => ele.uuid !== that.curUuid);
          return true;
        }
      });
    },
    toCopyFromShift: function () {
      this.showCopyShift = true;
    },
    onCopyFromShift: function (sitelist) {
      this.showCopyShift = false;
      this.SiteMappingData = sitelist;
    },
    toNewMapping: function () {
      this.curAction = "new";
      this.curMapData = { id: null, curType: "", curEvent: "" };
      this.mapToDialog = true;
    },
    toNew: function () {
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_shift",
        url: "/shift/add-shift-table/",
        data: {
          sequence: this.shiftData.sequence,
          shift_name: this.$transCommonLangKey(this.shiftData.shift_name),
          shift_description: this.$transCommonLangKey(
            this.shiftData.shift_description
          ),
          // shift_abbr: this.$transCommonLangKey(this.shiftData.shift_abbr),
          // 2020-09-03改为非国际化
          shift_abbr: this.shiftData.shift_abbr,
          shift_code: this.shiftData.shift_code,
          color_code: this.shiftData.color_code,
          shift_type_uuid: this.shiftData.shift_type_uuid.join(","),
          default_site_uuid: this.shiftData.default_site_uuid,
          // cost_center_uuid:this.shiftData.cost_center_uuid,
          start_utc_time: this.timeTerminal.start_time,
          start_time_time_zone: this.timeTerminal.start_utc,
          end_utc_time: this.timeTerminal.end_time,
          sequence: this.shiftData.sequence,
          end_time_time_zone: this.timeTerminal.end_utc,
          total_working_minutes: this.shiftData.total_working_minutes,
          effective_utc_datetime: this.$getTimeValue(
            this.shiftData.effective_utc_datetime
          ),
          effective_time_zone: this.shiftData.expired_time_zone, //sync utc
          expired_utc_datetime: this.$getTimeValue(
            this.shiftData.expired_utc_datetime
          ),
          expired_time_zone: this.shiftData.expired_time_zone,
          shift_property_group_uuid: this.shiftData.shift_property_group_uuid,
          ess_att_map_shift_event: this.curEventList,
          ess_map_punch_criteria_site: this.curCriteriaTypeList,
          remarks: this.shiftData.remarks,
        },
      }).then((res) => {
        that.$toBack();
      });
    },
    toEditMapping: function (item) {
      this.curAction = "edit";
      const that = this;
      this.curMapData = { id: null, curType: "", curEvent: "" };
      setTimeout(function () {
        that.curMapData = {
          id: item.id,
          curType: item.type_uuid,
          curEvent: item.event_uuid,
        };
      }, 300);
      this.mapToDialog = true;
    },
    toDeleteMapping: function () {
      const that = this;
      this.desserts.forEach(function (item, index) {
        if (item.id == that.curItem.id) {
          that.desserts.splice(index, 1);
        }
      });
      //排序
      this.desserts.sort((a, b) => {
        if (a.startTime > b.startTime) {
          return 1;
        } else if (a.startTime == b.startTime) {
          return 0;
        } else {
          return -1;
        }
      });
    },
    toEditAll: function () {
      this.showSelect = !this.showSelect;
    },
    toDelete(item) {
      const that = this;
      this.curItem = item;
      this.$confirmDo(this.$t("label_essweb_event_list_title")).then((res) => {
        if (res) that.toDeleteMapping();
      });
    },
    onNewMapping: function (obj) {
      const that = this;
      this.mapToDialog = false;
      if (this.desserts.length == 0) {
        obj.id = 0;
        that.desserts.push(obj);
        return;
      }
      //判断时区
      if (Number(this.timeTerminal.start_utc) != 0) {
        if (obj.startUtc != this.timeTerminal.start_utc) {
          that.$showMessage({
            title: that.$t("message_essweb_shift_form_zoneErrorTitle"),
            okText: that.$t("message_essweb_form_textField_selectAgain"),
            text: that.$t("error_essweb_shift_form_zoneOverlapLabel"),
            type: "error",
          });
          return false;
        }
      }
      //新增
      var maxid = 0;
      this.desserts.some(function (item, index) {
        if (
          item.type_uuid == obj.type_uuid &&
          item.event_uuid == obj.event_uuid
        ) {
          that.$showMessage({
            title: that.$t("message_essweb_form_textField_errNoticeTitle"),
            text: that.$t("error_essweb_shift_form_eventExistLabel"),
            type: "error",
          });
          return true;
        } else if (
          Number(obj.startTime) > Number(item.startTime) &&
          Number(obj.endTime) < Number(item.endTime)
        ) {
          // 判断时间段是否重合
          that.$showMessage({
            title: that.$t("message_essweb_shift_form_timeErrorTitle"),
            text: that.$t("error_essweb_shift_form_timeOverlapLabel"),
            type: "error",
          });
          return true;
        } else if (
          Number(obj.startTime) == Number(item.startTime) &&
          Number(obj.endTime) == Number(item.endTime)
        ) {
          // 判断时间段是否重合
          that.$showMessage({
            title: that.$t("message_essweb_shift_form_timeErrorTitle"),
            text: that.$t("error_essweb_shift_form_timeOverlapLabel"),
            type: "error",
          });
          return true;
        } else if (
          Number(item.startTime) < Number(obj.startTime) &&
          Number(obj.startTime) < Number(item.endTime)
        ) {
          // 判断时间段是否重合
          that.$showMessage({
            title: that.$t("message_essweb_shift_form_timeErrorTitle"),
            text: that.$t("error_essweb_shift_form_timeOverlapLabel"),
            type: "error",
          });
          return true;
        } else if (
          Number(item.startTime) < Number(obj.endTime) &&
          Number(obj.endTime) < Number(item.endTime)
        ) {
          // 判断时间段是否重合
          that.$showMessage({
            title: that.$t("message_essweb_shift_form_timeErrorTitle"),
            text: that.$t("error_essweb_shift_form_timeOverlapLabel"),
            type: "error",
          });
          return true;
        } else {
          maxid = item.id > maxid ? item.id : maxid;
          if (index == that.desserts.length - 1) {
            obj.id = maxid + 1;
            that.desserts.push(obj);
          }
        }
      });
      //排序
      this.desserts.sort((a, b) => {
        if (a.startTime > b.startTime) {
          return 1;
        } else if (a.startTime == b.startTime) {
          return 0;
        } else {
          return -1;
        }
      });
    },
    onEditMapping: function (obj) {
      const that = this;
      this.mapToDialog = false;
      var curindex = null;
      // 判断时区
      if (Number(this.timeTerminal.start_utc) != 0) {
        if (obj.startUtc != this.timeTerminal.start_utc) {
          that.$showMessage({
            title: that.$t("message_essweb_shift_form_zoneErrorTitle"),
            okText: that.$t("message_essweb_form_textField_selectAgain"),
            text: that.$t("error_essweb_shift_form_zoneOverlapLabel"),
            type: "error",
          });
          return;
        }
      }
      //some(),当return true 时，跳出循环
      this.desserts.some(function (item, index) {
        if (item.id != obj.id) {
          if (
            item.type_uuid == obj.type_uuid &&
            item.event_uuid == obj.event_uuid
          ) {
            that.$showMessage({
              title: that.$t("message_essweb_form_textField_errNoticeTitle"),
              text: that.$t("error_essweb_shift_form_eventExistLabel"),
              type: "error",
            });
            return true;
          }
          if (
            Number(obj.startTime) > Number(item.startTime) &&
            Number(obj.endTime) < Number(item.endTime)
          ) {
            // 判断时间段是否重合
            that.$showMessage({
              title: that.$t("message_essweb_shift_form_timeErrorTitle"),
              text: that.$t("error_essweb_shift_form_timeOverlapLabel"),
              type: "error",
            });
            return true;
          }
          if (
            Number(obj.startTime) == Number(item.startTime) &&
            Number(obj.endTime) == Number(item.endTime)
          ) {
            // 判断时间段是否重合
            that.$showMessage({
              title: that.$t("message_essweb_shift_form_timeErrorTitle"),
              text: that.$t("error_essweb_shift_form_timeOverlapLabel"),
              type: "error",
            });
            return true;
          }
          if (
            Number(item.startTime) < Number(obj.startTime) &&
            Number(obj.startTime) < Number(item.endTime)
          ) {
            // 判断时间段是否重合
            that.$showMessage({
              title: that.$t("message_essweb_shift_form_timeErrorTitle"),
              text: that.$t("error_essweb_shift_form_timeOverlapLabel"),
              type: "error",
            });
            return true;
          }
          if (
            Number(item.startTime) < Number(obj.endTime) &&
            Number(obj.endTime) < Number(item.endTime)
          ) {
            // 判断时间段是否重合
            that.$showMessage({
              title: that.$t("message_essweb_shift_form_timeErrorTitle"),
              text: that.$t("error_essweb_shift_form_timeOverlapLabel"),
              type: "error",
            });
            return true;
          }
        } else {
          curindex = index;
        }
        if (index == that.desserts.length - 1) {
          that.desserts[curindex].id = obj.id;
          that.desserts[curindex].type_uuid = obj.type_uuid;
          that.desserts[curindex].type = obj.type;
          that.desserts[curindex].group_uuid = obj.group_uuid;
          that.desserts[curindex].event_uuid = obj.event_uuid;
          that.desserts[curindex].name = obj.name;
          that.desserts[curindex].startTime = obj.startTime;
          that.desserts[curindex].startUtc = obj.startUtc;
          that.desserts[curindex].endTime = obj.endTime;
          that.desserts[curindex].endUtc = obj.endUtc;
        }
      });
      //排序
      this.desserts.sort((a, b) => {
        if (a.startTime > b.startTime) {
          return 1;
        } else if (a.startTime == b.startTime) {
          return 0;
        } else {
          return -1;
        }
      });
    },
  },
};
</script>
